import React, { useState } from "react";
import SaveChanges from "./saveChanges";
import { useParams } from "react-router-dom";
import WhiteLoading from "./whiteLoading";
import Info from "./info";

const RemoveStudentForm = (props) => {
    const [text, setText] = useState("Are you sure you want to remove this student?");
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const { courseCode } = useParams();

    const resetForm = () => {
        props.updateRemoveStudent(false);
    }

    const submitForm = async (e) => {
        e.preventDefault();

        if (requestLifeCycle) {
            return;
        }

        const url = process.env.REACT_APP_COURSE_API_URL + "/remove-student"

        const urlOptions = {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                courseCode: courseCode,
                studentEmail: props.email
            })
        }

        try {
            setRequestLifeCycle(true)
            const res = await fetch(url, urlOptions);
            const data = await res.json();

            if (res.status === 200) {
                setText("Student removed from course")
                props.updateRemoveStudent(false);
                window.location.reload();
            }
            else if (res.status === 401) {
                setText("Authentication error")
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            } else if (res.status === 404) {
                setText("Student not found")
            } else {
                setText("Status Code: " + res.status + " Error: " + data.detail)
            }

        } catch (error) {
            setText("Error: " + error.message)
            console.log(error);
        } finally {
            setRequestLifeCycle(false)
        }
    }

    return (
        <>
            <div className="black-back" onClick={ () => {props.updateRemoveStudent(false)} }>

            </div>
            <div className="add-a-course-form-container">
                <div className="add-a-course-form-content-container">
                    <form className="form-width">
                        <div className="add-course-title">
                            Remove Student
                        </div>
                        <div className="account-settings-content">
                            <div className="required-container" style={{ wordBreak: "break-all" }}>
                                {props.decodedEmail ? props.decodedEmail : props.email}
                            </div>   
                            <div className="banner">
                                {
                                    requestLifeCycle 

                                    ?
                                    
                                    <>
                                        <WhiteLoading />
                                    </>

                                    :

                                    <div className="banner-info">
                                        <Info />
                                        { text }
                                    </div>

                                }
                            </div>
                            <SaveChanges left="Cancel" right={{ small : "Update Roster", large : "Update Roster" }} resetForm={resetForm} submitForm={submitForm}/> 
                        </div>
                    </form> 
                </div>
            </div>
        </>
    );
}

export default RemoveStudentForm;